import httpClient from "http-client/http-client";

const BASE = "v1/community-portal/support-tickets";

/**
 * Create a new support ticket.
 * Account/audit may be inferred from the auth token on the BFF.
 * @param {{ service_account_id?: string, data: object, audit?: object }} body
 */
export async function createSupportTicket(body) {
  const { data, errors } = await httpClient.post({ url: BASE, body });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/**
 * Fetch support tickets with optional filters and pagination.
 * @param {{ service_account_id?: string, status?: string, from?: string, to?: string, current_page?: number, page_size?: number }} body
 */
export async function fetchSupportTickets(body) {
  const { data, errors } = await httpClient.post({ url: `${BASE}/list`, body });
  if (errors?.length) return { data: null, errors };
  return { data };
}

/**
 * Get ticket counts grouped by status for a given service account.
 * @param {{ service_account_ids: string[], statuses: string[] }} body
 */
export async function getTicketCounts() {
  const { data, errors } = await httpClient.post({
    url: `${BASE}/counts`,
    body:{},
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}
